__turbopack_context__.v({
  "floatingShell": "ScrollRevealFloating-module-scss-module__mSyi3q__floatingShell",
  "floatingShellWithBlocks": "ScrollRevealFloating-module-scss-module__mSyi3q__floatingShellWithBlocks",
  "isMobile": "ScrollRevealFloating-module-scss-module__mSyi3q__isMobile",
  "visible": "ScrollRevealFloating-module-scss-module__mSyi3q__visible",
});
